import React, { useState } from "react";

import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";

import CoverLayout from "layouts/authentication/components/CoverLayout";
import curved9 from "assets/images/curved-images/curved-6.jpg";
import Cookies from "universal-cookie";

import { loginRoute } from "api/routes";
import Loading from "components/Loading";

import { toast } from "react-toastify";

function SignIn() {
    const [loginInfo, setLoginInfo] = useState({
        phone_mail: "",
        password: "",
    });

    const [loading, setLoading] = useState(false);

    const cookies = new Cookies();

    const onSubmit = () => {
        if (!loginInfo?.phone_mail?.trim()) {
            return toast.error("لطفاً شماره موبایل یا ایمیل را وارد کنید.");
        }

        if (!loginInfo?.password) {
            return toast.error("لطفاً رمز عبور را وارد کنید.");
        }

        setLoading(true);

        const data = {
            phone_mail: loginInfo.phone_mail,
            password: loginInfo.password,
        };

        loginRoute(data, (isOk, data) => {
            setLoading(false);

            if (!isOk) {
                return toast.error(data.message);
            }

            cookies.set(
                "is_access",
                "aXNfYWNjZXNzOnRydWU",
                {
                    path: "/",
                    maxAge: 2592000,
                }
            );

            window.location.replace("/dashboard");
        });
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            onSubmit();
        }
    };

    return (
        <CoverLayout
            title=""
            description=""
            image={curved9}
        >
            <Loading loading={loading} />

           
                {/* Brand */}
                <SoftBox
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        mb: 3.5,
                    }}
                >
                    <SoftBox
                        component="img"
                        src="/images/logo.png"
                        alt="لوگو"
                        sx={{
                            width: {
                                xs: "120px",
                                sm: "145px",
                            },
                            height: "auto",
                            mb: 2,
                            objectFit: "contain",
                        }}
                    />

                    <SoftTypography
                        variant="h4"
                        fontWeight="bold"
                        sx={{
                            color: "#0f172a",
                            textAlign: "center",
                            fontSize: {
                                xs: "1.35rem",
                                sm: "1.55rem",
                            },
                            mb: 0.8,
                        }}
                    >
                        ورود به پنل مدیریت
                    </SoftTypography>

                    <SoftTypography
                        variant="body2"
                        sx={{
                            color: "#64748b",
                            textAlign: "center",
                            lineHeight: 1.9,
                            fontSize: "0.88rem",
                        }}
                    >
                        برای ورود، اطلاعات حساب کاربری خود را وارد کنید.
                    </SoftTypography>
                </SoftBox>

                <SoftBox
                    component="form"
                    role="form"
                    onSubmit={(event) => {
                        event.preventDefault();
                        onSubmit();
                    }}
                >
                    {/* Username */}
                    <SoftBox mb={2.5}>
                        <SoftBox mb={1}>
                            <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                sx={{
                                    color: "#334155",
                                    fontSize: "0.82rem",
                                }}
                            >
                             ایمیل
                            </SoftTypography>
                        </SoftBox>

                        <SoftInput
                            value={loginInfo.phone_mail}
                            onChange={(event) =>
                                setLoginInfo((prev) => ({
                                    ...prev,
                                    phone_mail: event.target.value,
                                }))
                            }
                            onKeyDown={handleKeyDown}
                            type="text"
                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    minHeight: "48px",
                                    borderRadius: "12px",
                                    backgroundColor: "#ffffff",
                                    transition: "all .2s ease",

                                    "& fieldset": {
                                        borderColor:
                                            "rgba(100,116,139,0.22)",
                                    },

                                    "&:hover fieldset": {
                                        borderColor:
                                            "rgba(2,132,199,0.55)",
                                    },

                                    "&.Mui-focused fieldset": {
                                        borderColor: "#0284C7",
                                        borderWidth: "1.5px",
                                    },
                                },

                                "& input": {
                                    fontSize: "0.9rem",
                                    fontWeight: 600,
                                    color: "#0f172a",
                                },

                                "& input::placeholder": {
                                    color: "#94a3b8",
                                    opacity: 1,
                                    fontWeight: 500,
                                },
                            }}
                        />
                    </SoftBox>

                    {/* Password */}
                    <SoftBox mb={2.5}>
                        <SoftBox mb={1}>
                            <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                sx={{
                                    color: "#334155",
                                    fontSize: "0.82rem",
                                }}
                            >
                                رمز عبور
                            </SoftTypography>
                        </SoftBox>

                        <SoftInput
                            value={loginInfo.password}
                            onChange={(event) =>
                                setLoginInfo((prev) => ({
                                    ...prev,
                                    password: event.target.value,
                                }))
                            }
                            onKeyDown={handleKeyDown}
                            type="password"
                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    minHeight: "48px",
                                    borderRadius: "12px",
                                    backgroundColor: "#ffffff",
                                    transition: "all .2s ease",

                                    "& fieldset": {
                                        borderColor:
                                            "rgba(100,116,139,0.22)",
                                    },

                                    "&:hover fieldset": {
                                        borderColor:
                                            "rgba(2,132,199,0.55)",
                                    },

                                    "&.Mui-focused fieldset": {
                                        borderColor: "#0284C7",
                                        borderWidth: "1.5px",
                                    },
                                },

                                "& input": {
                                    textAlign: "right",
                                    direction: "ltr",
                                    fontSize: "0.95rem",
                                    fontWeight: 600,
                                    color: "#0f172a",
                                },

                                "& input::placeholder": {
                                    textAlign: "right",
                                    direction: "rtl",
                                    color: "#94a3b8",
                                    opacity: 1,
                                },
                            }}
                        />
                    </SoftBox>

                    {/* Button */}
                    <SoftBox mt={3}>
                        <SoftButton
                            type="submit"
                            fullWidth
                            disabled={loading}
                            sx={{
                                minHeight: "48px",
                                borderRadius: "12px",
                                fontSize: "0.95rem",
                                fontWeight: 900,
                                color: "#ffffff",
                                background:
                                    "linear-gradient(135deg, #0284C7 0%, #0ea5e9 100%)",
                                boxShadow:
                                    "0 14px 30px rgba(2,132,199,0.25)",
                                transition: "all .2s ease",

                                "&:hover": {
                                    background:
                                        "linear-gradient(135deg, #0369a1 0%, #0284C7 100%)",
                                    boxShadow:
                                        "0 18px 36px rgba(2,132,199,0.32)",
                                    transform: "translateY(-1px)",
                                },

                                "&:disabled": {
                                    opacity: 0.65,
                                    color: "#ffffff",
                                },
                            }}
                        >
                            {loading ? "در حال ورود..." : "ورود به پنل"}
                        </SoftButton>
                    </SoftBox>

                    {/* Footer */}
                    <SoftBox
                        mt={3}
                        pt={2.2}
                        sx={{
                            borderTop:
                                "1px solid rgba(226,232,240,0.85)",
                        }}
                    >
                        <SoftTypography
                            variant="caption"
                            sx={{
                                display: "block",
                                textAlign: "center",
                                color: "#94a3b8",
                                fontSize: "0.75rem",
                                lineHeight: 1.8,
                            }}
                        >
                            سامانه مدیریت کافه‌بری
                        </SoftTypography>
                    </SoftBox>
                </SoftBox>
        </CoverLayout>
    );
}

export default SignIn;